<script setup lang="ts">
defineProps<{
  dropActive: boolean
}>()

const emit = defineEmits<{
  triggerUploadInput: [event: MouseEvent]
  uploadButtonKeydown: [event: KeyboardEvent]
  uploadButtonHover: [event: MouseEvent, hover: boolean]
  uploadButtonFocus: [event: FocusEvent, focused: boolean]
  fileSelected: [event: Event]
}>()
</script>

<template>
  <div class="qq-total-progress-bar-container-selector qq-total-progress-bar-container qq-hide">
    <div role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" class="qq-total-progress-bar-selector qq-progress-bar qq-total-progress-bar"></div>
  </div>
  <div
    class="qq-upload-drop-area-selector qq-upload-drop-area"
    :class="{ 'qq-upload-drop-area-active': dropActive, 'qq-hide': !dropActive }"
    qq-hide-dropzone
  >
    <span class="qq-upload-drop-area-text-selector">Drop files here</span>
  </div>
  <div
    class="qq-upload-button-selector qq-upload-button"
    role="button"
    tabindex="0"
    aria-label="Upload a file"
    @click="emit('triggerUploadInput', $event)"
    @keydown="emit('uploadButtonKeydown', $event)"
    @mouseenter="emit('uploadButtonHover', $event, true)"
    @mouseleave="emit('uploadButtonHover', $event, false)"
    @focus="emit('uploadButtonFocus', $event, true)"
    @blur="emit('uploadButtonFocus', $event, false)"
  >
    <div>Upload a file</div>
    <input
      type="file"
      name="qqfile"
      multiple
      @click.stop
      @focus="emit('uploadButtonFocus', $event, true)"
      @blur="emit('uploadButtonFocus', $event, false)"
      @change="emit('fileSelected', $event)"
    >
  </div>
  <span class="qq-drop-processing-selector qq-drop-processing qq-hide">
    <span>Processing dropped files...</span>
    <span class="qq-drop-processing-spinner-selector qq-drop-processing-spinner"></span>
  </span>
</template>
